export { BiometryEndpoints } from './api/endpoints';
export { BIOMETRY_DISPATCH_API } from './api/dispatch';
export {
  TYPE_PHOTO_ID,
  UPLOADED_PHOTO_STATUSES,
  CAMERA_MODE_PROP,
  REQUIRED_ID_DOCUMENTS,
  CONSTRAINTS,
  VIDEO_MIMETYPE,
  RECORDER_TIMEOUT_MS,
  EMPTY_DOCUMENT_UPLOAD_REASONS,
} from './utils/upload.const';
export * from './utils/consts';
